<ion-header *ngIf="!device.isMobile()">
  <ion-toolbar>
    <ion-title>{{ "PUZZLE.feedback_modal.feature." + featureId + ".title" | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-grid>
    <ion-row *ngIf="!textInputMode" class="puzzle-modal-grow">
      <ion-col>
        <h1>{{ "PUZZLE.feedback_modal.feature." + featureId + ".address" | translate }}</h1>
        <p>{{ "PUZZLE.feedback_modal.feature." + featureId + ".score" | translate }}</p>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="textInputMode" class="puzzle-modal-grow">
      <ion-col>
        <p>{{ "PUZZLE.feedback_modal.feature." + featureId + ".text" | translate }}</p>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="textInputMode" class="puzzle-modal-grow">
      <ion-col>
        <ion-textarea
          fill="solid"
          [(ngModel)]="text"
          placeholder="{{ 'PUZZLE.feedback_modal.feature.' + featureId + '.placeholder' | translate }}"
          labelPlacement="floating"
          label="{{ 'PUZZLE.feedback_modal.feature.' + featureId + '.label' | translate }}"
        />
      </ion-col>
    </ion-row>

    <ion-row *ngIf="textInputMode">
      <ion-col>
        <p>{{ "PUZZLE.feedback_modal.feature." + featureId + ".email_text" | translate }}</p>
        <ion-input
          fill="solid"
          [(ngModel)]="email"
          placeholder="{{ 'PUZZLE.feedback_modal.feature.' + featureId + '.email_placeholder' | translate }}"
          email
          type="email"
          labelPlacement="floating"
          label="{{ 'PUZZLE.feedback_modal.feature.' + featureId + '.email_label' | translate }}"
        />
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer>
  <div *ngIf="!textInputMode" class="puzzle-modal-buttons">
    <ion-button color="primary" (click)="setScore('thumbs-down')" fill="solid">
      {{ "PUZZLE.feedback_modal.feature." + featureId + ".button_thumbs_down" | translate }}
      <ion-icon slot="start" name="thumbs-down-sharp" />
    </ion-button>
    <ion-button color="primary" (click)="setScore('no-opinion')" fill="solid">
      {{ "PUZZLE.feedback_modal.feature." + featureId + ".button_no_opinion" | translate }}
    </ion-button>
    <ion-button color="primary" (click)="setScore('thumbs-up')" fill="solid">
      {{ "PUZZLE.feedback_modal.feature." + featureId + ".button_thumbs_up" | translate }}
      <ion-icon slot="end" name="thumbs-up-sharp" />
    </ion-button>
  </div>

  <div *ngIf="textInputMode" class="puzzle-modal-buttons">
    <ion-button color="primary" (click)="closeModal()" fill="clear">
      {{ "PUZZLE.feedback_modal.feature." + featureId + ".button_close" | translate }}
      <ion-icon slot="start" name="close-sharp" />
    </ion-button>
    <ion-button color="primary" (click)="setText()" fill="solid">
      {{ "PUZZLE.feedback_modal.feature." + featureId + ".button_send" | translate }}
      <ion-icon slot="end" name="send-sharp" />
    </ion-button>
  </div>
</ion-footer>


